import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SvgComponent, SvgIconType } from '@app/base-components';
import { TranslatePipe } from 'haba-core';

interface PaymentMethod {
  icon: SvgIconType;
  width: string;
  height: string;
}

@Component({
  selector: 'app-checkout-footer',
  templateUrl: './checkout-footer.component.html',
  styleUrls: ['./checkout-footer.component.scss'],
  imports: [RouterLink, SvgComponent, TranslatePipe],
})
export class CheckoutFooterComponent {
  phoneNumber: string = '0 95 64 / 929 66 66';
  paymentMethods: PaymentMethod[] = [
    {
      icon: 'payment/mastercard',
      width: '31px',
      height: '24px',
    },
    {
      icon: 'payment/paypal',
      width: '65.5px',
      height: '16px',
    },
    {
      icon: 'payment/visa',
      width: '50px',
      height: '16px',
    },
  ];
}
